import { useEffect, useState } from 'react'
import confetti from 'canvas-confetti'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation3({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    // Feux d'artifice
    const duration = 5000
    const animationEnd = Date.now() + duration
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 }

    function randomInRange(min: number, max: number) {
      return Math.random() * (max - min) + min
    }

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now()

      if (timeLeft <= 0) {
        return clearInterval(interval)
      }

      const particleCount = 50 * (timeLeft / duration)

      confetti({
        ...defaults,
        particleCount: Math.floor(particleCount),
        origin: { x: randomInRange(0.1, 0.9), y: randomInRange(0.2, 0.6) },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc', '#ffffff'],
        shapes: ['circle', 'star'],
        scalar: randomInRange(0.8, 1.2)
      })
    }, 400)

    setTimeout(() => setShowBadge(true), 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        <div className={`transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-50 opacity-0'}`}>
          <div className="relative">
            {/* Glow effect */}
            <div className="absolute inset-0 w-32 h-32 sm:w-40 sm:h-40 bg-tessan-yellow rounded-2xl blur-xl opacity-50" />

            {/* Badge */}
            <div className="relative w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl mb-6">
              <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
            </div>
          </div>

          {/* Nom du badge */}
          <div className="text-2xl sm:text-4xl font-black text-tessan-cream text-center animate-pulse drop-shadow-[0_0_30px_rgba(252,245,204,0.8)]">
            {badge.name}
          </div>

          {/* Points */}
          <div className="text-xl text-tessan-yellow text-center mt-2">
            +{badge.points_awarded} points
          </div>

          {/* Description */}
          <div className="text-tessan-cream/70 text-center mt-4 max-w-[280px] sm:max-w-xs">
            {badge.description}
          </div>
        </div>
      </div>
    </AnimationLayout>
  )
}
